import { openKeyboardShortcutsDialog } from "#app/lib/keyboard-shortcuts-dialog-context";
import { useHotkey } from "./use-hotkey";

/**
 * ⌘/Ctrl+/ opens the keyboard-shortcuts reference — the chord the dialog
 * itself and the account menu advertise (`KEYBOARD_SHORTCUTS_SHORTCUT` in the
 * catalog). A ⌘/Ctrl chord is never typing, so this fires inside editable
 * targets and over a modal, like ⌘K does.
 */
export function useKeyboardShortcutsHotkey(): void {
  useHotkey({
    code: "Slash",
    mod: true,
    allowInEditor: true,
    allowInModal: true,
    handler: openKeyboardShortcutsDialog,
  });
}
